import React, {useEffect} from 'react';

import {loadNewPaymentsOptions} from '@ibibo/load-payments';

import * as SS from '../../../CancelFlow/CancelLeftBlock/CancellationBody/CancellationBody.styles';

const PaymentBlock = ({updateActiveTab, paySessionId}) => {
  
  if (!paySessionId) {
    return null;
  }

  if (!window.initPayment) {
    loadNewPaymentsOptions({
      paySessionId,
      containerId: 'gi_paymentframe'
    });
  } else {
    window.initPayment({
      paySessionId,
      containerId: 'gi_paymentframe'
    })
  }

  return(
    <SS.CancelBreakUpMainWrap>
      <SS.CancelBreakUpHeaderWrap>
        <SS.BreakupHeaderMainText>Payment Mode</SS.BreakupHeaderMainText>
      </SS.CancelBreakUpHeaderWrap>

      <div id="gi_paymentframe">loading...</div>
      
      <SS.CancelBtnWrap>
        <SS.BackOptionWrap onClick={() => updateActiveTab('cost')}>
          <SS.BackOptionText>Back to Additional Cost</SS.BackOptionText>
        </SS.BackOptionWrap>
        <SS.CancelButtonWrap>
          <SS.CancelBtn>CONFIRM</SS.CancelBtn>
        </SS.CancelButtonWrap>
      </SS.CancelBtnWrap>

    </SS.CancelBreakUpMainWrap>
  );
}

export default PaymentBlock;